// ================================================================================
// wp-block-modal.js
// スライダーのスクリプトファイル
// ================================================================================

document.addEventListener('DOMContentLoaded', function() {

	// -----------------------------
	// Modal (with animation)
	// -----------------------------
	const overlay = document.getElementById('js-modal-reserve');
	const closeBtn = document.getElementById('js-modal-reserve-close');
	if (!overlay || !closeBtn) return;

	const dialog = overlay.querySelector('.wp-block-modal-reserve-dialog');
	const openButtons = document.querySelectorAll('.js-modal-reserve button');

	const applyECodeSelection = function(){

		let savedId = '';

		try {
			savedId = localStorage.getItem('last_location_id') || '';
		} catch(e){}

		if (!savedId) return;

		const eCode = overlay.querySelector('#e-code');
		if (!eCode) return;

		const exists = Array.prototype.some.call(eCode.options, function(opt){
			return opt.value === savedId;
		});

		if (exists) {
			eCode.value = savedId;
		}
	};

	const applyCarClassSelection = function(){

		const carClassId = window.reserveModalCarClass || '';
		if (!carClassId) return;

		const carClass = overlay.querySelector('#car-class');
		if (!carClass) return;

		const exists = Array.prototype.some.call(carClass.options, function(opt){
			return opt.value === carClassId;
		});

		if (exists) {
			carClass.value = carClassId;
		}
	};

	const openModal = function(){

		applyCarClassSelection();
		applyECodeSelection();

		overlay.classList.add('is-active');
		overlay.setAttribute('aria-hidden', 'false');
		document.body.classList.add('is-modal-reserve-open');

		overlay.offsetHeight;
		overlay.classList.add('is-open');
	};

	const closeModal = function(){
		overlay.classList.remove('is-open');
		overlay.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('is-modal-reserve-open');
	};

	openButtons.forEach(function(btn){
		btn.addEventListener('click', function(){
			const target = btn.getAttribute('data-modal-target');
			if (target && target !== '#js-modal-reserve') return;
			openModal();
		});
	});

	closeBtn.addEventListener('click', function(){
		closeModal();
	});

	overlay.addEventListener('click', function(e){
		if (e.target === overlay) {
			closeModal();
		}
	});

	document.addEventListener('keydown', function(e){
		if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
			closeModal();
		}
	});

	// 閉じアニメが終わったらdisplayを落とす
	overlay.addEventListener('transitionend', function(e){
		if (!overlay.classList.contains('is-open') && e.target === overlay) {
			overlay.classList.remove('is-active');
		}
	});

	// -----------------------------
	// Reserve Form (予約では閉じない)
	// -----------------------------
	document.querySelectorAll('.wp-block-acf-modal-reserve form#js-reserve-form').forEach(function(form){

		const qs = (sel) => form.querySelector(sel);
		const pad = (num) => String(num).padStart(2, '0');

		const today = new Date();
		const tomorrow = new Date(today);
		tomorrow.setDate(today.getDate() + 1);

		const depYear = qs('#dep-year');
		const depMonth = qs('#dep-month');
		const depDay = qs('#dep-day');

		const retYear = qs('#ret-year');
		const retMonth = qs('#ret-month');
		const retDay = qs('#ret-day');

		if (depYear) depYear.value = String(today.getFullYear());
		if (depMonth) depMonth.value = pad(today.getMonth() + 1);
		if (depDay) depDay.value = pad(today.getDate());

		if (retYear) retYear.value = String(tomorrow.getFullYear());
		if (retMonth) retMonth.value = pad(tomorrow.getMonth() + 1);
		if (retDay) retDay.value = pad(tomorrow.getDate());

		const btn = qs('#js-reserve-button');
		if (!btn) return;

		btn.addEventListener('click', function(){

			const depYearVal = depYear ? depYear.value : '';
			const depMonthVal = depMonth ? depMonth.value : '';
			const depDayVal = depDay ? depDay.value : '';
			const depTimeVal = (qs('#dep-time') || {}).value || '';

			const retYearVal = (retYear || {}).value || '';
			const retMonthVal = (retMonth || {}).value || '';
			const retDayVal = (retDay || {}).value || '';
			const retTimeVal = (qs('#ret-time') || {}).value || '';

			const eCodeVal = (qs('#e-code') || {}).value || '';
			const carClassEl = qs('#car-class');
			const carClassVal = carClassEl ? carClassEl.value : '';

			const rCodeEl = form.querySelector('input[name="rCode"]');
			const rCodeVal = rCodeEl ? rCodeEl.value : '';

			const oldError = form.querySelector('#car-class-error');
			if (oldError) oldError.remove();

			if (carClassEl && carClassVal === '0') {
				const error = document.createElement('div');
				error.id = 'car-class-error';
				error.textContent = '※希望の車両を選択してください。';
				carClassEl.insertAdjacentElement('afterend', error);
				return;
			}

			const depDateTime = depYearVal + depMonthVal + depDayVal + depTimeVal;
			const retDateTime = retYearVal + retMonthVal + retDayVal + retTimeVal;

			if (!carClassVal || !eCodeVal) {
				alert('クラスまたは店舗を選択して下さい。');
				return;
			}

			const url = 'https://rent.toyota.co.jp/rakuraku/step1.aspx'
				+ '?carClass=' + encodeURIComponent(carClassVal)
				+ '&rCode=' + encodeURIComponent(rCodeVal)
				+ '&eCode=' + encodeURIComponent(eCodeVal)
				+ '&depDateTime=' + depDateTime
				+ '&retDateTime=' + retDateTime;

			// 予約では閉じない
			window.open(url, '_blank');
		});
	});

});
